export default "__VITE_ASSET__BFuWdX4E__"